import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ModeOption {
  value: string;
  label: string;
  shortLabel: string;
  icon: string;
}

@Injectable({ providedIn: 'root' })
export class ModeService {
  private readonly storageKey = 'activeMode';

  readonly modeOptions: ModeOption[] = [
    { value: 'user',       label: 'Usar como cliente',        shortLabel: 'Cliente',        icon: 'user' },
    { value: 'business',   label: 'Usar como negocio',        shortLabel: 'Negocio',        icon: 'briefcase' },
    { value: 'ambassador', label: 'Usar como embajador',      shortLabel: 'Embajador',      icon: 'award' },
    { value: 'admin',      label: 'Usar como administrador',  shortLabel: 'Administrador',  icon: 'shield' },
  ];

  private activeModeSubject = new BehaviorSubject<string>(this.getStoredMode());
  readonly activeMode$ = this.activeModeSubject.asObservable();

  get activeMode(): string {
    return this.activeModeSubject.value;
  }

  private getStoredMode(): string {
    return localStorage.getItem(this.storageKey) || 'user';
  }

  setMode(mode: string): void {
    localStorage.setItem(this.storageKey, mode);
    this.activeModeSubject.next(mode);
  }

  /** Inicializa el modo activo al hacer login. */
  initFromSession(): void {
    const stored = localStorage.getItem(this.storageKey);
    const available = this.getAvailableProfiles();
    if (!stored || !available.find(o => o.value === stored)) {
      this.setMode(available.length > 0 ? available[0].value : 'user');
    } else {
      this.activeModeSubject.next(stored);
    }
  }

  getAvailableProfiles(): ModeOption[] {
    try {
      const raw = localStorage.getItem('currentUser');
      if (!raw) return [this.modeOptions[0]];
      const user = JSON.parse(raw);
      const profiles: string[] = Array.isArray(user.profiles) ? user.profiles : ['user'];
      return this.modeOptions.filter(o => profiles.includes(o.value));
    } catch {
      return [this.modeOptions[0]];
    }
  }

  getActiveModeOption(): ModeOption | undefined {
    return this.modeOptions.find(o => o.value === this.activeMode);
  }
}
